module.exports = __webpack_public_path__ + "img/doc-file.bb849ade.svg";